import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "analysis-view" }
const _hoisted_2 = { class: "analysis-view__list" }
const _hoisted_3 = { class: "analysis-view__content" }

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useMeasurementStore } from '@/store/measurementStore'
import { usePositionStore } from '@/store/positionStore'
import { useMqttStore } from '@/store/mqttStore'
import { storeToRefs } from 'pinia'
import TitleBar from '@/components/layout/TitleBar.vue'
import MeasurementList from '@/components/measurement/MeasurementList.vue'
import CurrentSetup from '@/components/measurement/CurrentSetup.vue'
import BikeIllustration from '@/components/preview/common/BikeIllustration.vue'
import {
  heartRate,
  instantaneousPower,
  instantaneousCadence,
} from '@/mqttDefinitions'
import {
  BfButton,
  BfFlex,
  BfMeasurement,
  ButtonIconPosition,
  ButtonState,
  ButtonType,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { MqttTopic } from '@/mqttDefinitions/topics'


export default /*@__PURE__*/_defineComponent({
  __name: 'AnalysisView',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()

const measurementStore = useMeasurementStore()
const positionStore = usePositionStore()
const { absolutePosition, isCalibrated, isLatestMeasurementCalibrated } =
  storeToRefs(positionStore)
const { measurements, selectedMeasurement } = storeToRefs(measurementStore)

const changeHardware = () => {
  router.push({ name: 'setup' })
}

const addMeasurement = () => {
  measurementStore.create({
    crankset: {
      active: selectedMeasurement.value?.crankset.active,
    },
    handlebar: {
      active: selectedMeasurement.value?.handlebar.active,
      x: absolutePosition.value.handlebarX,
      y: absolutePosition.value.handlebarY,
    },
    saddle: {
      active: selectedMeasurement.value?.saddle.active,
      x: absolutePosition.value.saddleX,
      y: absolutePosition.value.saddleY,
    },
    pedal: {
      active: selectedMeasurement.value?.pedal.active,
    },
  })
}

const mqttStore = useMqttStore()
const { getMessageOnTopic, getRawValueOnTopic } = storeToRefs(mqttStore)

const heartRateValue = computed(() => getMessageOnTopic.value(heartRate))

const instantaneousPowerValue = computed(() =>
  getMessageOnTopic.value(instantaneousPower),
)

const instantaneousCadenceValue = computed(() => {
  const rawValue = getRawValueOnTopic.value(
    MqttTopic.RESISTANCE_INSTANTANEOUS_CADENCE,
  )

  if (rawValue && typeof rawValue === 'object' && 'value' in rawValue) {
    return 0
  } else {
    return Number(rawValue)?.toString() === 'NaN'
      ? 0
      : Math.floor(Number(rawValue))
  }
})

const next = () => {
  router.push({ name: 'data' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_unref(t)('measurement.measurements')), 1),
      _createVNode(MeasurementList)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TitleBar, {
        title: _unref(t)('measurement.currentPosition')
      }, {
        measurements: _withCtx(() => [
          _createVNode(_unref(BfFlex), null, {
            default: _withCtx(() => [
              (heartRateValue.value)
                ? (_openBlock(), _createBlock(_unref(BfMeasurement), {
                    key: 0,
                    value: heartRateValue.value,
                    label: _unref(heartRate).unit,
                    icon: "/icons/measurements/heart.svg"
                  }, null, 8, ["value", "label"]))
                : _createCommentVNode("", true),
              _createVNode(_unref(BfMeasurement), {
                value: instantaneousPowerValue.value,
                label: _unref(instantaneousPower).unit,
                icon: "/icons/measurements/wattage.svg"
              }, null, 8, ["value", "label"]),
              _createVNode(_unref(BfMeasurement), {
                value: instantaneousCadenceValue.value,
                label: _unref(instantaneousCadence).unit,
                icon: "/icons/measurements/rpm.svg"
              }, null, 8, ["value", "label"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(BfButton), {
            type: _unref(ButtonType).Outlined,
            icon: "/icons/52-Arrows-Diagrams/01-Arrows/arrow-left-1.svg",
            onClick: changeHardware
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('measurement.changeHardware')), 1)
            ]),
            _: 1
          }, 8, ["type"]),
          _createVNode(_unref(BfButton), {
            state: 
            _unref(measurements).length <= 10 &&
            _unref(isCalibrated) &&
            _unref(isLatestMeasurementCalibrated)
              ? _unref(ButtonState).Enabled
              : _unref(ButtonState).Disabled
          ,
            type: _unref(ButtonType).Outlined,
            onClick: addMeasurement
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('measurement.addMeasurement')), 1)
            ]),
            _: 1
          }, 8, ["state", "type"]),
          _createVNode(_unref(BfButton), {
            state: 
            _unref(measurements).length > 2 ? _unref(ButtonState).Enabled : _unref(ButtonState).Disabled
          ,
            "icon-position": _unref(ButtonIconPosition).Right,
            icon: "/icons/52-Arrows-Diagrams/01-Arrows/arrow-right-1.svg",
            onClick: next
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.next')), 1)
            ]),
            _: 1
          }, 8, ["state", "icon-position"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(CurrentSetup),
      _createVNode(BikeIllustration)
    ])
  ]))
}
}

})